export default __webpack_public_path__ + "static/media/Image-17.ed676656.png";